var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer bg-secondary"},[_c('div',{staticClass:"container-fluid"},[_c('span',{staticClass:"text-muted"},[_vm._v("Copyright © "+_vm._s(_vm.year)+" - Conectra Sistemas. All rights reserved")])])])}
var staticRenderFns = []

export { render, staticRenderFns }